import { Button, Tooltip } from '@shared/components';

interface QSetMarkExamUsageAsInactiveButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function QSetMarkExamUsageAsInactiveButton(
  props: Readonly<QSetMarkExamUsageAsInactiveButtonProps>,
) {
  const { disabled, onClick } = props;

  return (
    <Tooltip
      title={disabled ? 'กรุณาเลือกเฉพาะชุดข้อสอบที่อยู่ใน\nสถานะ “Ready” เท่านั้น' : ''}
      placement='top'
      maxWidth={220}
    >
      <Button
        disabled={disabled}
        size='small'
        color='secondary'
        variant='outlined'
        onClick={onClick}
        sx={{
          '&.Mui-disabled': {
            pointerEvents: 'auto',
          },
        }}
      >
        Mark as Inactive
      </Button>
    </Tooltip>
  );
}
